var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-caption"},[_vm._v(_vm._s(_vm.message)+" "+_vm._s(_vm.countdown))])
}
var staticRenderFns = []

export { render, staticRenderFns }